import useLanguageStore from '~/store/language';
import useProfileStore from '~/store/profile';

export function useCustomRequestHeaders() {
  const activeLanguage = useLanguageStore().getActiveLanguageCode;
  const token = useProfileStore().token;
  const distinctId = useProfileStore().distinctId;

  return {
    'Accept-Language': activeLanguage || 'en',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    'X-Distinct-Id': distinctId,
    'X-Client': 'web',
  };
}
